<button class="btn btn-outline btn-primary">
    <i class="material-symbols-outlined"> {{icon}} </i>
    <span>{{text}}</span>
  </button>